export enum InputMethodEnum {
  CallOver = 1,
  SleepCapture = 2,
  MarkSense = 3
};